<lib-auth-tsi 
[production]="produccion"
[module]="nombreProyecto"
[versionApp]="versionApp"
[authForm]="authForm"
[product]="module"
(loginEvent)="auth($event)"
(beforeInstall)="onBeforeInstall()"
/>
